import { Directive, HostBinding, HostListener } from '@angular/core';
import { DragAndDropService } from '@shared/services/drag-and-drop/drag-and-drop.service';

@Directive({
  selector: '[dragAndDrop]'
})
export class DragAndDropDirective {
  @HostBinding('style.background') private background = '#ffffff';

  constructor(private _dragAndDropService: DragAndDropService) {}

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#e6e6e6';
  }
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#ffffff';
  }
  @HostListener('drop', ['$event']) public onDrop(evt) {
    this.background = '#ffffff';
  }
}
